var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttachment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7034 4.31127C16.9551 2.56291 14.1106 2.56291 12.3622 4.31127L5.68566 10.9878C5.47961 11.1938 5.47961 11.5276 5.68566 11.7337C5.89171 11.9397 6.22552 11.9397 6.43157 11.7337L13.1081 5.05718C14.4041 3.76216 16.6614 3.76216 17.9575 5.05718C19.2942 6.39392 19.2942 8.56932 17.9575 9.90607L8.6346 19.3339C7.83719 20.1313 6.44788 20.1313 5.6505 19.3339C4.82785 18.5113 4.82785 17.173 5.6505 16.3503L14.6004 7.29487C14.8992 6.99611 15.4205 6.99611 15.7193 7.29487C16.0278 7.6034 16.0278 8.10568 15.7193 8.41425L7.14281 17.0962C6.96492 17.2741 6.96492 17.6642 7.14281 17.8421C7.34887 18.0481 7.68267 18.0481 7.88872 17.8421L16.4652 9.16012C17.1853 8.43994 17.1853 7.2691 16.4652 6.54896C15.7677 5.8515 14.5509 5.85252 13.8545 6.54896L4.90459 15.6044C3.68024 16.8287 3.68024 18.8554 4.90459 20.0798C5.50267 20.6779 6.29748 21 7.14278 21C7.98808 21 8.78296 20.6779 9.38051 20.0798L18.7034 10.6519C20.4517 8.90359 20.4517 6.05959 18.7034 4.31127Z",
    fill: "#241A0F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.8f737fa9b15a0dcb52d752f57f2377ef.svg";
export { ForwardRef as ReactComponent };